module.exports = __webpack_public_path__ + "img/065.ded841fa.png";